/**
 * Blueprint metadata `variables[].type` and table `columns[].type` values (YAML).
 * Distinct from RTE {@link DIRECTIVE_VARIABLE_TYPES} in directives config (`text` vs `string`, etc.).
 */

export const METADATA_VARIABLE_TYPE_TABLE = "table" as const;
export const METADATA_VARIABLE_TYPE_STRING = "string" as const;
export const METADATA_VARIABLE_TYPE_TEXT = "text" as const;
export const METADATA_VARIABLE_TYPE_NUMBER = "number" as const;
export const METADATA_VARIABLE_TYPE_LIST = "list" as const;

export const isTableMetadataVariableType = (
  type: string | undefined,
): boolean => type === METADATA_VARIABLE_TYPE_TABLE;
